/* istanbul ignore file */
import React from 'react';
import { InputList, InputListProps } from 'framework/form';

interface VacancyDetailsListInputProps extends InputListProps {}

const VacancyDetailsListInput = ({ inputTemplate, ...props }: VacancyDetailsListInputProps) => {
  return <InputList {...props} inputTemplate={inputTemplate} defaultValue={{}} />;
};

export default VacancyDetailsListInput;
